import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Buttons from "components/UI/Button/Buttons";
import "components/UI/StepperForm/StepperAddOrEditForm.scss";
import { editar } from "services/crudFirebase";
import { v4 as uuidv4 } from "uuid";
import GetStepContentComponent from "./GetStepContentComponent";
import {
	formatNewItem,
	handleSetItem,
	reverseFormatCompatibleData,
} from "Functions/functions";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
	},
	button: {
		marginTop: theme.spacing(1),
		marginRight: theme.spacing(1),
	},
	actionsContainer: {
		marginBottom: theme.spacing(2),
	},
	resetContainer: {
		padding: theme.spacing(3),
	},
}));

export default function StepperAddOrEditForm({
	item,
	type,
	handleClose,
	items,
	setItems,
	steps
}) {
	const classes = useStyles();
	const [error, setError] = useState("");
	const [validation, setValidation] = useState(false);
	const [activeStep, setActiveStep] = useState(0);

	const [marca, setMarca] = useState(
		type === "edit" ? [[]] : [[uuidv4(), "", false]]
	);
	const [num, setNum] = useState(
		type === "edit" ? [[]] : [[uuidv4(), "", false]]
	);
	const [titulo, setTitulo] = useState(
		type === "edit" ? [[]] : [[uuidv4(), "", false]]
	);
	const [img, setImg] = useState(
		type === "edit" ? [[]] : [[uuidv4(), "", false]]
	);
	const [precio, setPrecio] = useState(type === "edit" ? item.Precio : "");
	const [tipo, setTipo] = useState(type === "edit" ? item.Tipo : "");
	const [disableInput, setDisableInput] = useState(type === "edit" ? item.DesabilitarNum : false);

	useEffect(() => {
		if (type === "edit" && img[0].length === 0) {
			const [formatBrand, formatModelo, formatNum] =
				reverseFormatCompatibleData(item);
			const newImg = item.Img.map((i) => [uuidv4(), i, true]);
			setImg(newImg);

			const newBrands = formatBrand.map((i) => [uuidv4(), i, true]);
			setMarca(newBrands);

			const newModel = formatModelo.map((i) => [uuidv4(), i, true]);
			setTitulo(newModel);

			const newNum = formatNum.map((i) => [uuidv4(), i, true]);
			setNum(newNum);
		}
	}, []);

	useEffect(() => {
		handleValidationImg();
	}, [img]);

	const handleValidationImg = () => {
		const fields = [...img];
		const validationResult = fields.map((i) => {
			return i[2];
		});
		const result = validationResult.every((e) => e);
		setValidation(result);
		!result && setError("Los campos son obligatorios");
	};

	useEffect(() => {
		handleValidationBrands();
	}, [marca]);

	const handleValidationBrands = () => {
		const fields = [...marca];
		const validationResult = fields.map((i) => {
			return i[2];
		});
		const result = validationResult.every((e) => e);
		setValidation(result);
		!result && setError("Los campos son obligatorios");
	};

	useEffect(() => {
		if(!disableInput) {
			handleValidationNum();
		}
	}, [num]);

	useEffect(() => {
		if(disableInput) {
			setValidation(true)
			setError("")
		}
	}, [disableInput])

	const handleValidationNum = () => {
			const fields = [...num];
			const validationResult = fields.map((i) => {
				return i[2];
			});
			const result = validationResult.every((e) => e);
			setValidation(result);
			!result && setError("Los campos son obligatorios");
	};

	useEffect(() => {
		handleValidationModel();
	}, [titulo]);

	const handleValidationModel = () => {
		const fields = [...titulo];
		const validationResult = fields.map((i) => {
			return i[2];
		});
		const result = validationResult.every((e) => e);
		setValidation(result);
		!result && setError("Los campos son obligatorios");
	};

	const handleUpdateItem = (newItem) => {
		const updateData = [...items];
		let returnElements = [];
		updateData.forEach((i) => {
			if (item.id === i.id) {
				returnElements = [...returnElements, newItem];
			} else {
				returnElements = [...returnElements, i];
			}
		});
		setItems(returnElements);
		editar(newItem, "CatalogoFlexores");
	};

	const handleNext = (e) => {
		if (e !== undefined) {
			e.preventDefault();
		}
		if (validation) {
			setError("");
			setActiveStep((prevActiveStep) => prevActiveStep + 1);
			if (activeStep === steps.length - 1) {
				handleClose();

				const newItem = formatNewItem(marca, titulo, num, precio, tipo, img, item !== undefined ? item.id : uuidv4(), type, disableInput);
				// const newItem = formatNewItem(marca, titulo, num, precio, tipo, img, item !== undefined ? item.id : uuidv4(), type);

				if (type !== "edit") {
					setItems(handleSetItem(newItem, items));
				} else {
					handleUpdateItem(newItem);
				}
			}
		} else {
			if (error !== "Ingrese solo números") {
				setError("Los campos son obligatorios");
			}
		}
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};

	return (
		<div className={classes.root}>
			<Stepper
				activeStep={activeStep}
				orientation="vertical"
				className="stepperWrap"
			>
				{steps.map((label, index) => (
					<Step key={label}>
						<StepLabel>{label}</StepLabel>
						<StepContent>
							<form onSubmit={handleNext} className="addOrEditForm">
								<GetStepContentComponent numberStep={index} setMarca={setMarca} marca={marca} setValidation={setValidation} setTitulo={setTitulo} titulo={titulo} setTipo={setTipo} tipo={tipo} setNum={setNum} num={num} setImg={setImg} img={img} setPrecio={setPrecio} precio={precio} setError={setError} validation={validation} error={error} type={type} disableInput={disableInput} setDisableInput={setDisableInput} />
								{/* <GetStepContentComponent numberStep={index} setMarca={setMarca} marca={marca} setValidation={setValidation} setTitulo={setTitulo} titulo={titulo} setTipo={setTipo} tipo={tipo} setNum={setNum} num={num} setImg={setImg} img={img} setPrecio={setPrecio} precio={precio} setError={setError} validation={validation} error={error} type={type} /> */}
							</form>
							<div className="groupButtons">
								<input
									className="groupButtons__btn--submit"
									type="submit"
									onClick={handleNext}
									value={
										activeStep === steps.length - 1 && type === "add"
											? "Agregar"
											: activeStep === steps.length - 1 && type === "edit"
											? "Editar"
											: "Siguiente"
									}
								/>
								<Buttons
									onClick={activeStep === 0 ? handleClose : handleBack}
									className="groupButtons__btn"
								>
									{activeStep === 0 ? "Cancelar" : "Anterior"}
								</Buttons>
							</div>
						</StepContent>
					</Step>
				))}
			</Stepper>
		</div>
	);
}
